import React, { useState, useEffect } from 'react'
import { FaUser, FaInfoCircle, FaSave } from 'react-icons/fa';
import { Spin, notification, DatePicker } from 'antd'
import dayjs from 'dayjs';
import moment from 'moment';
import axios from 'axios';
import { LoadingOutlined } from '@ant-design/icons';
export default function CpnDaoHo({ loanId }) {
  const [closeDate, setCloseDate] = useState('01/01/1999');
  const [amount, setAmount] = useState('0');
  const [loadingItem, setLoadingItem] = useState(false); // Track loading state for each row

  const whiteSpinnerIcon = <LoadingOutlined style={{ fontSize: 24, color: 'white' }} spin />;

  useEffect(() => {
    const today = new Date();
    const day = String(today.getDate()).padStart(2, '0'); // Lấy ngày và thêm số 0 nếu cần
    const month = String(today.getMonth() + 1).padStart(2, '0'); // Lấy tháng (0-11) và thêm số 0
    const year = today.getFullYear(); // Lấy năm

    const formattedDate = `${day}/${month}/${year}`;
    setCloseDate(formattedDate); // Lưu vào state
  }, []); // Chỉ chạy một lần khi component được mount

  const [name, setName] = useState('');
  const [totalMoneyNeedPay, setTotalMoneyNeedPay] = useState(0);
  const [fromDate, setFromDate] = useState('01/01/1999');
  const [debitMoney, setDebitMoney] = useState(0);
  const [totalMoneyNeedClose, setTotalMoneyNeedClose] = useState(0)
  const [traGopMoi, setTraGopMoi] = useState(0);
  const [tienDuaKhach, setTienDuaKhach] = useState(0);
  const [loanTime, setLoanTime] = useState(0);
  const [frequency, setFrequency] = useState(0);

  useEffect(() => {
    const token = localStorage.getItem('token'); // Thay 'your_token_key' bằng key thực tế
    fetch(`${process.env.REACT_APP_API_DB_URL}/loan-credit/${loanId}`,
      {
        method: 'GET', // Hoặc 'POST' nếu cần thiết
        headers: {
          'Authorization': `Bearer ${token}`, // Thêm token vào headers
          'Content-Type': 'application/json' // Nếu cần
        }
      })
      .then(response => response.json())
      .then(data => {
        const formattedDate = moment(data.FROM_DATE).format('DD-MM-YYYY');
        setFromDate(formattedDate);
        setDebitMoney(data.DEBIT_MONEY);
        setTraGopMoi(data.TOTAL_MONEY);
        setTienDuaKhach(data.TOTAL_MONEY_RECEIVED);
        setTotalMoneyNeedPay(data.TOTAL_MONEY_NEED_PAY);
        setLoanTime(data.LOAN_TIME);
        setFrequency(data.FREQUENCY);
        setTotalMoneyNeedClose(Number(data.TOTAL_MONEY_RECEIVED) - Number(data.TOTAL_MONEY_NEED_PAY) - Number(data.DEBIT_MONEY));
      })
      .catch(error => console.error('Error fetching data:', error))
  }, []);


  const showNotification = (message, type) => {
    notification[type]({
      description: message,
      placement: 'topRight', // Notification position
    });
  };

  const handleChangeLocaleTotalMoneyTienDuaKhach = (e) => {
    // Chỉ lấy giá trị số và loại bỏ dấu phẩy
    const value = e.target.value.replace(/\./g, ''); // Xóa dấu phẩy
    setTienDuaKhach(value);
  };

  const handleChangeLocaleTotalMoneyTraGopMoi = (e) => {
    // Chỉ lấy giá trị số và loại bỏ dấu phẩy
    const value = e.target.value.replace(/\./g, ''); // Xóa dấu phẩy
    setTraGopMoi(value);
  };

  const handleChangeLoanTime = (e) => {

    setLoanTime(e.target.value);

  };
  const handleChangeFrequency = (e) => {
    setFrequency(e.target.value);
  };
  const handleSubmit = async () => {
    // sumInterest + totalMoney + debitMoney + Number(amount)
    const payload = {
    };
    try {
      setLoadingItem(true);
      const token = localStorage.getItem('token'); // Lấy token từ localStorage
      const response = await axios.post(
        `${process.env.REACT_APP_API_DB_URL}/close-loan-credit/${loanId}`,
        payload,
        {
          headers: {
            Authorization: `Bearer ${token}` // Thêm token vào header
          }
        }
      );

      let message = '';
      let type = '';
      if (response.status === 200) {
        message = `Đóng HĐ thành công, mã HĐ: ${loanId}`;
        type = 'success';
      } else {
        message = 'Đóng HĐ thất bại';
        type = 'error';
      }

      showNotification(message, type);
      // console.log('Response:', response.data);
    } catch (error) {
      console.error('Error saving contract:', error);
    } finally {
      setLoadingItem(false);
    }
  };

  useEffect(() => {
    console.log(tienDuaKhach)
    setTotalMoneyNeedClose(Number(tienDuaKhach) - Number(totalMoneyNeedPay) - Number(debitMoney));
  }, [tienDuaKhach, closeDate]);

  // 


  console.log("renders")
  return (
    <div className="p-8">
      <div className="flex flex-col">
        <div className="mb-4 flex items-start w-full max-w-xs">
          <label className="block text-gray-700 text-sm font-bold mr-4 flex-shrink-0 w-1/2" htmlFor="date">
            Ngày đảo họ <span className="text-red-500">*</span>
          </label>
          <div className="flex items-center">
            <DatePicker
              value={closeDate ? dayjs(closeDate, 'DD-MM-YYYY') : null} // Ensure value is controlled
              format={'DD/MM/YYYY'}
              onChange={(date, dateString) => {
                setCloseDate(dateString); // Update fromDate when a new date is picked
              }}
            />
          </div>
        </div>

        <div className="mb-4 flex items-start w-full max-w-xs">
        <label className="block text-gray-700 text-sm font-bold mr-4 flex-shrink-0 w-1/2">
            Trả góp mới<span className="text-red-500">*</span>
            {/* <span className='ml-4'>{}</span> */}
          </label>
          <div className="relative">
            <input
              type="text"
              className="w-full border border-gray-300 p-2 rounded"
              value={traGopMoi ? Number(traGopMoi).toLocaleString('vi-VN') : ''}
              onChange={handleChangeLocaleTotalMoneyTraGopMoi}
            />
          </div>
        </div>

        <div className="mb-4 flex items-start w-full max-w-xs">
        <label className="block text-gray-700 text-sm font-bold mr-4 flex-shrink-0 w-1/2">
            Tiền đưa khách<span className="text-red-500">*</span>
            {/* <span className='ml-4'>{}</span> */}
          </label>
          <div className="relative">
            <input
              type="text"
              className="w-full border border-gray-300 p-2 rounded"
              value={tienDuaKhach ? Number(tienDuaKhach).toLocaleString('vi-VN') : ''}
              onChange={handleChangeLocaleTotalMoneyTienDuaKhach}
            />
          </div>
        </div>


        <div className="mb-4 flex items-start w-full max-w-xs">
        <label className="block text-gray-700 text-sm font-bold mr-4 flex-shrink-0 w-1/2">
            Bốc trong vòng <span className="text-red-500">*</span>
          </label>

          <input
            type="number"
            className="w-full border border-gray-300 p-2 rounded"
            placeholder="Nhập Số ngày vay"
            value={loanTime}
            onChange={handleChangeLoanTime}
          />
        </div>

        <div className="mb-4 flex items-start w-full max-w-xs">
        <label className="block text-gray-700 text-sm font-bold mr-4 flex-shrink-0 w-1/2">
            Số ngày đóng tiền <span className="text-red-500">*</span>
          </label>
          <input
            type="number"
            className="w-full border border-gray-300 p-2 rounded"
            placeholder="VD: 3 ngày đóng 1 lần thì điền số 3"

            value={frequency}
            onChange={handleChangeFrequency}
          />
        </div>

        <div className="mb-4 flex items-start w-full max-w-xs">
          <label className="block text-gray-700 text-sm font-bold mr-4 flex-shrink-0 w-1/2" htmlFor="date">
            Tiền khách nhận về
          </label>
          <div className="flex items-center">
          <label>{totalMoneyNeedClose.toLocaleString('vi-VN')} VNĐ
            </label>
          </div>
        </div>


        <div className="mb-4 flex items-start w-full max-w-xs">
          <div className="block text-gray-700 text-sm font-bold mr-4 flex-shrink-0 w-1/2" htmlFor="amount" />

          <div className="flex flex-col items-center mt-4">
            <button
              className="bg-blue-500 text-white px-4 py-2 rounded flex items-center justify-center relative"
              onClick={handleSubmit}
            >
              <FaSave className="mr-2" />
              <span>Đóng HĐ</span>
              {loadingItem && ( // Show Spin only when loading
                <span className="ml-3">
                  <Spin indicator={whiteSpinnerIcon} />
                </span>
              )}
            </button>
          </div>
        </div>

      </div>
    </div>
  );
}
